<template>
    <div class="cw-right">
        <fileUpload></fileUpload>
        <center></center>
        <latestNews></latestNews>
    </div>
</template>

<script>
import fileUpload from './components/fileUpload.vue'
import center from './components/center.vue'
import latestNews from './components/latestNews.vue'

export default {

    components: { fileUpload, center, latestNews },

    data() {
        return {

        }
    },

    methods:{

    }
}

</script>

<style lang="scss" scoped>
.cw-right {
    width: 100%;
    height: 100%;
    border-radius: 9px;
    background: #ffffff;
}
</style>
